// ** Initial State
const initialState = {
  data: [],
  total: 1,
  params: {},
  songsDownUrl: "",
  error: null,
};
const AdsReducer = (state = initialState, action) => {
  switch (action.type) {
    case "GET_ALL_ADS":
      return {
        ...state,
        data: action.data,
        total: action.totalPages,
      };
    case "EMPTY_ERROR":
    case "EDIT_ADS_SUCCESS":
      return { ...state, error: null };
    case "EDIT_ADS_FAIL":
      return { ...state, error: action.payload };
    case "DOWNLOAD_ADS":
      return { ...state, songsDownUrl: action.data };
    default:
      return { ...state };
  }
};

export default AdsReducer;
